import BaseAbility from './base-ability';
import { service } from '@ember/service';
import { checkReleaseAvailability, RELEASE_DATE } from '../utils/release';
import { PREFIX_VAGRANT_REGISTRY } from '../utils/permission-types/index';

export default class VagrantRegistryAbility extends BaseAbility {
  @service config;

  prefix = PREFIX_VAGRANT_REGISTRY;

  get canRelease() {
    return checkReleaseAvailability(this.config.app?.deployGeo, RELEASE_DATE);
  }
}
